export const mediaLinks = [
  {
    name: "LinkedIn",
    description: "Link to my linkedin",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-plain.svg",
    link: "https://www.linkedin.com/in/christopher-luu-542691149",
  },
  {
    name: "GitHub",
    description: "Link to my GitHub",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
    link: "https://github.com/christopher-luu97",
  },
  {
    name: "Medium",
    description: "Link to my Medium",
    icon: "https://www.svgrepo.com/show/340609/logo-medium.svg",
    link: "https://medium.com/@cluu.codes1337",
  },
  {
    name: "Youtube",
    description: "Link to my YouTube",
    icon: "https://www.svgrepo.com/show/513089/youtube-168.svg",
    link: "https://www.youtube.com/@chris_codes",
  },
];
